import ACTION from '../action_constant';
import {ajaxPost, ajaxGet, ajaxPostWithToken, ajaxGetWithToken} from '../util/ajax';
import API from '../api_config';

const messageActions = {

    getMessageThread: function(params){
      return (dispatch) => {
        return ajaxGetWithToken({
          url: API.getMessageThread + '?isShipping=' + params.isShipping + '&count=' + params.count + '&timestamp=' + params.timestamp,
          success: (data) => {
              dispatch({
                type: ACTION.MESSAGES.MESSAGE_THREAD,
                data: {
                    messages: data.messages,
                    isShipping: params.isShipping,
                    nextUrl: data.nextUrl,
                    carryingCount: data.carryingCount,
                    receivingCount: data.receivingCount,
                    shippingCount: data.shippingCount
                }
              })
          },
          error: (error) => {
            console.log('error' + error)
          }
        })
      }

    },
    updateMessageThreads: function(params){
      return (dispatch) => {
        return ajaxGetWithToken({
          url: API.baseUrl +  params.nextUrl + '&isShipping=' + params.isShipping ,
          success: (data) => {
            dispatch({
              type: ACTION.MESSAGES.UPDATE_MESSAGE_THREAD,
              data: {
                messages: data.messages,
                isShipping: params.isShipping,
                nextUrl: data.nextUrl,
                carryingCount: data.carryingCount,
                receivingCount: data.receivingCount,
                shippingCount: data.shippingCount
              }
            })
          }
        })
      }
    },
    getFirebaseAuthToken: () => {
      return (dispatch) => {
        return ajaxGetWithToken({
          url: API.firebaseToken,
          data: {"deviceTypeId": 3},
          success: (data) => {
          },
          error: (error) => {
          }
        });
      }
    },
    sendMessage: (paramObj) => {
      return (dispatch) => {
        return ajaxPostWithToken({
            url : API.sendMessage,
            data: paramObj,
            success: (data) => {
            },
            error: (error) => {
            }
        });
      }
    }
}


module.exports = messageActions;



// WEBPACK FOOTER //
// app/messages/messages_action.jsx